import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Activity } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      // Redirect based on role
      if (result.user.role === 'nurse') {
        navigate('/nurse');
      } else if (result.user.role === 'doctor') {
        navigate('/doctor');
      } else if (result.user.role === 'manager') {
        navigate('/manager');
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  const quickLogin = (role, variant = null) => {
    if (role === 'nurse') {
      setEmail('emma.chen@jersey.health');
      setPassword('nurse123');
    } else if (role === 'doctor') {
      if (variant === 2) {
        setEmail('sarah.jones@jersey.health');
        setPassword('doctor123');
      } else {
        setEmail('amir.patel@jersey.health');
        setPassword('doctor123');
      }
    } else if (role === 'manager') {
      setEmail('jane.roberts@jersey.health');
      setPassword('manager123');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center mb-4">
            <img src="/REACH_LOGO.png" alt="Reach Logo" className="h-20 w-auto bg-transparent" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">DJ_Medi_Wallet_25</h1>
          <p className="text-gray-600 mt-2">Digital Hospital Paging System</p>
          <p className="text-sm text-gray-500 mt-1">Digital Jersey AI Hackathon 2025</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-lg shadow-xl p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="your.email@jersey.health"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="••••••••"
                required
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          {/* Quick Login (Demo) */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 text-center mb-3">Demo Quick Login:</p>
            <div className="space-y-2">
              <div className="grid grid-cols-2 gap-2">
                <button
                  onClick={() => quickLogin('doctor')}
                  className="px-3 py-2 text-sm bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium"
                >
                  Doctor 1
                </button>
                <button
                  onClick={() => quickLogin('doctor', 2)}
                  className="px-3 py-2 text-sm bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium"
                >
                  Doctor 2
                </button>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <button
                  onClick={() => quickLogin('nurse')}
                  className="px-3 py-2 text-sm bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors"
                >
                  Nurse
                </button>
                <button
                  onClick={() => quickLogin('manager')}
                  className="px-3 py-2 text-sm bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 transition-colors"
                >
                  Manager
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-sm text-gray-600">
          <p>Built for Jersey General Hospital</p>
          <p className="mt-1">Health & Wellbeing Challenge</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
